import React from 'react';
import styles from './HeroSection.module.css';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const HeroSection = () => {
    return (
        <div className={styles.container}>
            <div className={styles.heroCard}>
                <div className={styles.backgroundEffects}>
                    <div className={styles.blurTopLeft} />
                    <div className={styles.blurBottomRightLarge} />
                    <div className={styles.blurBottomLeft} />
                    <div className={styles.blurRightPink} />
                    <div className={styles.blurTopLeftPink} />
                    <div className={styles.blurBottomCenterPink} />
                    <div className={styles.blurRightSmallYellow} />
                    <div className={styles.backgroundPattern} />
                </div>

                <div className={styles.content}>
                    <OptimizedMotionH1 className={styles.mainHeading} type="slide-down" delay={0.2}>
                        <span className={styles.gradientText}>Spark Ideas on </span>
                        <br />
                        <span className={styles.gradientText}>Demand</span>
                    </OptimizedMotionH1>

                    <div className={styles.descriptionContainer}>
                        <OptimizedMotionP
                            className={styles.description}
                            type="slide-up"
                            delay={0.4}
                        >
                            The built‑in Inspiration Engine analyzes trending topics, competitor
                            messaging, and historical winners to propose campaign themes that fit
                            your voice. One click generates ideas for blog posts, social series, or
                            email drips—no blank‑page paralysis.
                        </OptimizedMotionP>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
